// Same engineering hierarchy as fanxingOS, inside the school's own storage.
// Keep this module usable by the server and browser; never accept a caller's
// arbitrary account prefix as an authenticated identity.
export const teachingProjectId = "5c7470dd-2040-4c90-9911-bcda87789d7c";
export const schoolStorageBucket = "duanju-school-1335253334";
export const schoolStorageRegion = "ap-beijing";
export function storageUuid(value) {
  if (typeof value !== "string" || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)) throw new Error("INVALID_STORAGE_UUID");
  return value.toLowerCase();
}
export function safeRelativePath(value) {
  if (typeof value !== "string" || !value || value.length > 2048 || /[\\\x00-\x1f\x7f]/.test(value)
    || value.split("/").some(part => !part || part === "." || part === "..")) throw new Error("INVALID_STORAGE_PATH");
  return value;
}
export const accountRoot = (accountId) => `${storageUuid(accountId)}.user`;
export const engineeringRoot = (accountId, projectId = teachingProjectId) => `${accountRoot(accountId)}/engineeringProjects/${storageUuid(projectId)}.fanxing`;
export const engineeringObjectKey = (accountId, projectId, rel) => `${engineeringRoot(accountId, projectId)}/${safeRelativePath(rel)}`;
export function courseObjectKey(accountId, role, caseId) {
  if (!["teacher", "student"].includes(role) || !/^[a-z0-9_-]+$/i.test(caseId)) throw new Error("INVALID_COURSE_SCOPE");
  return `${accountRoot(accountId)}/curriculum/${role}/${caseId}.json`;
}
export function accountObjectPath(accountId, key) {
  const prefix = `${accountRoot(accountId)}/`;
  if (!key.startsWith(prefix)) throw new Error("CACHE_ACCOUNT_MISMATCH");
  return safeRelativePath(key.slice(prefix.length));
}
